import {Injectable} from '@angular/core';
import {ThemeService} from './theme.service';
import {BrandingService} from '../api/branding.service';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { BrandingLegal } from "../../shared/models/branding.model";

export type LegalDocumentsDTO = {
  termsAndConditionsEs: string;
  termsAndConditionsEn: string;
  termsAndConditionsFr: string;
  privacyPolicyEs: string;
  privacyPolicyEn: string;
  privacyPolicyFr: string;
}

@Injectable({providedIn: 'root'})
export class LegalDocumentsService {

  constructor(private themeService: ThemeService, private branding: BrandingService) {
  }

  getTermsAndConditions(lang: string): Observable<string> {
    return this.getLegalDocuments().pipe(
      map((legalDocuments: LegalDocumentsDTO) => {
        switch (lang) {
          case 'es':
            return legalDocuments.termsAndConditionsEs || legalDocuments.termsAndConditionsEn;
          case 'en':
            return legalDocuments.termsAndConditionsEn;
          case 'fr':
            return legalDocuments.termsAndConditionsFr || legalDocuments.termsAndConditionsEn;
          default:
            return legalDocuments.termsAndConditionsEn;
        }
      })
    );
  }

  getPrivacyPolicy(lang: string): Observable<string> {
    return this.getLegalDocuments().pipe(
      map((legalDocuments: LegalDocumentsDTO) => {
        switch (lang) {
          case 'es':
            return legalDocuments.privacyPolicyEs || legalDocuments.privacyPolicyEn;
          case 'en':
            return legalDocuments.privacyPolicyEn;
          case 'fr':
            return legalDocuments.privacyPolicyFr || legalDocuments.privacyPolicyEn;
          default:
            return legalDocuments.privacyPolicyEn;
        }
      })
    );
  }

  getLegalDocuments(): Observable<LegalDocumentsDTO> {
    return this.themeService.getLegal().pipe(
      map((legal: BrandingLegal) => ({
        termsAndConditionsEn: legal.en.terms_url,
        termsAndConditionsEs: legal.es.terms_url,
        termsAndConditionsFr: legal.fr.terms_url,
        privacyPolicyEn: legal.en.privacy_url,
        privacyPolicyEs: legal.es.privacy_url,
        privacyPolicyFr: legal.fr.privacy_url,
      }))
    );
  }
}
